import { z } from 'zod';
import { Money } from './money';
import { PermissionMap } from './permissions';

export const StaffAssignment = z.object({
  assignmentId: z.string(),
  locationId: z.string(),
  locationName: z.string(),
  roleId: z.string(),
  roleName: z.string(),
});
export type StaffAssignment = z.infer<typeof StaffAssignment>;

export const StaffRow = z.object({
  userId: z.string(),
  fullName: z.string(),
  assignments: z.array(StaffAssignment),
  isOwner: z.boolean(),
  isActive: z.boolean(),
  hasPin: z.boolean(),
  hourlyRate: Money.nullable(),
});
export const StaffList = z.object({ rows: z.array(StaffRow) });
export type StaffList = z.infer<typeof StaffList>;

export const PatchStaff = z.object({
  hourlyRate: Money.min(0).nullable().optional(),
  isActive: z.boolean().optional(),
  /** новый PIN: сервер проверит коллизии по всем точкам сотрудника */
  pin: z.string().regex(/^\d{4}$/).optional(),
});
export type PatchStaff = z.infer<typeof PatchStaff>;

/** Отчёт «Команда»: часы за период и «к выплате». */
export const AttendanceRow = z.object({
  userId: z.string(),
  fullName: z.string(),
  minutes: z.number().int(),
  openNow: z.boolean(),   // явка ещё открыта — человек на месте
  hourlyRate: Money.nullable(),
  pay: Money.nullable(),  // null, если ставка не задана
  /** чаевые за период — часть дохода, которую нельзя прятать */
  tips: Money.default(0),
});
export const AttendanceReport = z.object({ rows: z.array(AttendanceRow) });
export type AttendanceReport = z.infer<typeof AttendanceReport>;

export const RoleRow = z.object({
  id: z.string(),
  name: z.string(),
  permissions: PermissionMap,
  discountLimitPct: z.number().int().min(1).max(100).nullable(),
});
export const RolesList = z.object({ rows: z.array(RoleRow) });
export type RolesList = z.infer<typeof RolesList>;

export const CreateRole = z.object({
  name: z.string().min(2).max(40),
  permissions: PermissionMap,
});
export type CreateRole = z.infer<typeof CreateRole>;

export const PatchRole = z.object({
  name: z.string().min(2).max(40).optional(),
  permissions: PermissionMap.optional(),
  discountLimitPct: z.number().int().min(1).max(100).nullable().optional(),
});
export type PatchRole = z.infer<typeof PatchRole>;

/** Найм из офиса: имя, PIN и роль на точке. */
export const CreateStaff = z.object({
  fullName: z.string().min(2).max(60),
  pin: z.string().regex(/^\d{4}$/),
  roleId: z.string(),
  locationId: z.string(),
  hourlyRate: Money.min(0).optional(),
});
export type CreateStaff = z.infer<typeof CreateStaff>;

export const AddAssignment = z.object({
  locationId: z.string(),
  roleId: z.string(),
});
export type AddAssignment = z.infer<typeof AddAssignment>;
